export default __webpack_public_path__ + "static/bg-notes--mobile-42f812c735e0e4352af139babf4a2ffa.webp";